/**
 * PrivacyARPrivacyPageView
 *
 * Page component for PrivacyARPrivacyPageView
 * Path: /ar/privacy
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PrivacyARPrivacyPageView as __PrivacyARPrivacyPageView } from '@/components/traits/PrivacyARPrivacyPageView';
import { PrivacyARPrivacyAnalyticsView as __PrivacyARPrivacyAnalyticsView } from '@/components/traits/PrivacyARPrivacyAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface PrivacyARPrivacyPageViewProps {
  // Add any page-level props here
}

export function PrivacyARPrivacyPageView(_props: PrivacyARPrivacyPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-privacy:meta.title"],"description":["i18n/t","std-almadar-privacy:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/privacy"},{"locale":"ar","path":"/ar/privacy"},{"locale":"sl","path":"/sl/privacy"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PrivacyARPrivacyPageView config={{ initPayload: __navState }} />
          <__PrivacyARPrivacyAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default PrivacyARPrivacyPageView;
